var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(-3.574 -3.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M17.088,15.984a7.43,7.43,0,0,0,1.484-5.438,7.546,7.546,0,0,0-6.825-6.585,7.495,7.495,0,0,0-1.484,14.916,7.518,7.518,0,0,0,5.44-1.447l6.182,6.186a.934.934,0,0,0,1.385,0h0a.953.953,0,0,0,0-1.4Zm-4.995.9a5.411,5.411,0,0,1-4.754-1.566A5.518,5.518,0,0,1,5.862,10.5a5.433,5.433,0,0,1,9.193-2.938,5.546,5.546,0,0,1-2.962,9.323Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifyingGlass.9bbbefbc8dd873eeb9411f19bc58ce41.svg";